<button class="button-copy" (click)="textToClipboard(contentCopy)">Copiar</button>